var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLogged && _vm.showNavbar)?_c('navbar'):_vm._e(),(_vm.isLogged)?_c('main-sidebar'):_vm._e(),_c('main',[_c('router-view')],1),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }